module.exports = __webpack_public_path__ + "static/media/  (121).eebed8af.jpg";